import { CardSection } from '@components/CardSection'
import CreditCardList from 'basket/components/CreditCardList'
import Button from '@components/Button'
import PriceBreakdownModal from '@components/PriceBreakdownModal'
import { Total } from '@booking/components/utilities'
import { allowPurchaseSingleTicketSelector, creditCardsSelector, makePurchasePendingSelector } from 'basket/selectors'
import {
    disabledCardsSelector,
    lastBookingBasketItemTotalPriceSelector,
    parkingModeSelector,
    ratesAreLoadingSelector,
    selectedCreditCardSelector,
} from '@booking/selectors'
import { selectCreditCard } from '@booking/actions'
import { SEARCH_MODE_PREPAID } from 'search/constants'

const PaySection = ({
    disabled,
    selectCreditCard,
    cards,
    selectedCreditCard,
    makePurchasePending,
    allowPurchase,
    purchaseError,
    onPayForParkingClick,
    onGoToBasketClick,
    areRatesPending,
    isAddAnotherBookingFlow,
    updateValidation,
    parkingMode,
    totalPrice,
}) => {
    const [priceBreakdownModalOpen, setPriceBreakdownModalOpen] = React.useState(false)

    React.useEffect(() => {
        updateValidation({
            selectCardError: false,
        })

        if (cards.length > 0 || (selectedCreditCard && !selectedCreditCard.default)) {
            const card = cards.find(card => card.default) || cards[0]
            selectCreditCard(card.id)
        }
    }, [selectCreditCard, cards])

    return (
        <CardSection disabled={disabled} className="select" title={<T>booking.pay.for.parking</T>}>
            <div className="row">
                <div className="col-sm-6 col-xs-12">
                    <div className="booking__main__section__select">
                        <T>booking.select.payment.card</T>
                    </div>
                    <CreditCardList
                        selectedCard={selectedCreditCard}
                        onCardSelected={selectCreditCard}
                        disabled={makePurchasePending === true}
                    />
                </div>
                <div className="col-sm-6 col-xs-12 d-flex flex-column align-items-end">
                    <Button
                        onClick={() => setPriceBreakdownModalOpen(true)}
                        className="mb-2"
                        size="small"
                        btnStyle="link">
                        <T>price.breakdown</T>
                    </Button>
                    {priceBreakdownModalOpen && (
                        <PriceBreakdownModal
                            isLoading={makePurchasePending === true}
                            disabled={!allowPurchase}
                            onClose={() => setPriceBreakdownModalOpen(false)}
                            payForParking={onPayForParkingClick}
                            error={purchaseError}
                        />
                    )}
                    {totalPrice && <Total totalPrice={totalPrice.amount} currencySymbol={totalPrice.currencySymbol} />}
                    {!isAddAnotherBookingFlow ? (
                        <Button
                            size="large"
                            block
                            onClick={onPayForParkingClick}
                            isLoading={makePurchasePending === true}
                            disabled={!allowPurchase || areRatesPending}>
                            {parkingMode === SEARCH_MODE_PREPAID ? (
                                <T>booking.btn.pay.for.parking.prepaid</T>
                            ) : (
                                <T>booking.btn.pay.for.parking</T>
                            )}
                        </Button>
                    ) : (
                        <Button
                            size="large"
                            block
                            onClick={onGoToBasketClick}
                            isLoading={makePurchasePending === true}
                            disabled={!allowPurchase || areRatesPending || makePurchasePending === true}>
                            <T>booking.btn.pay.for.parking.basket</T>
                        </Button>
                    )}
                </div>
            </div>
        </CardSection>
    )
}

export default compose(
    connect(
        createStructuredSelector({
            makePurchasePending: makePurchasePendingSelector,
            disabledCards: disabledCardsSelector,
            parkingMode: parkingModeSelector,
            cards: creditCardsSelector,
            selectedCreditCard: selectedCreditCardSelector,
            allowPurchase: allowPurchaseSingleTicketSelector,
            areRatesPending: ratesAreLoadingSelector,
            totalPrice: lastBookingBasketItemTotalPriceSelector,
        }),
        {
            selectCreditCard,
        }
    )
)(PaySection)
